module.exports = __webpack_public_path__ + "img/绿幕抠图--场景切换.0c62427c.png";